/* =====================================================================
 * Product Slider
 * =====================================================================
 * 1. Main Slider
 * ===================================================================*/

import { tns } from 'tiny-slider/src/tiny-slider';

(function (doc) {

  /* ---------------------------------------------------------------------
   * 1. Main Slider
   * -------------------------------------------------------------------*/

  const tableSlider = doc.querySelector('.tableSlider');
  if (!tableSlider) return;
  new tns({
    preventScrollOnTouch: 'auto',
    container: tableSlider,
    controlsText: ['', ''],
    loop: false,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      840: {
        items: 2
      },
      960: {
        items: 2
      }
    }
  });

}(document));
